export const initializeAggRegionSteeringHint = (fromValue?: string | null) => {
	if (fromValue && !window['GLOBAL_AGG_REGION_STEERING_HINT']) {
		window['GLOBAL_AGG_REGION_STEERING_HINT'] = fromValue;
	}
	return window['GLOBAL_AGG_REGION_STEERING_HINT'];
};
